import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sector'
})
export class SectorPipe implements PipeTransform {
  transform(dataset: any[], args: any): any {
    //return dataset.filter(row => row.sector === args.id);
    return dataset.filter(row => row.sector.indexOf(args.id) > -1);
  }
}
